'use client';

import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useId } from "../../utils/hooks/useId.js";
import { getRestProps } from "./utils/getRestProps.js";
import { getItemProps } from "./utils/getItemProps.js";
import { getButtonProps } from "./utils/getButtonProps.js";
import { getA11yTriggerProps } from "./utils/getA11yTriggerProps.js";
import { MenuItemContent } from "./MenuItem.Content.js";
function MenuItemAsButtonComponent(props, ref) {
  const { disabled, onClick, active } = props;
  const id = useId();
  return /* @__PURE__ */ jsx("li", { ...getItemProps(props), children: /* @__PURE__ */ jsx(
    "button",
    {
      ...getRestProps(props),
      ...getButtonProps(props),
      ...getA11yTriggerProps(id, props),
      "aria-current": active ? "true" : void 0,
      "aria-disabled": disabled ? true : void 0,
      disabled: void 0,
      ref,
      type: "button",
      onClick: !disabled ? onClick : void 0,
      children: /* @__PURE__ */ jsx(MenuItemContent, { ...props, id })
    }
  ) });
}
const MenuItemAsButton = forwardRef(MenuItemAsButtonComponent);
export {
  MenuItemAsButton
};
